import StaffLogin from "@/components/StaffLogin";
export default function AdminLogin() {
  return <StaffLogin role="admin" title="Admin Login" subtitle="Sign in with your credentials & weekly access code." />;
}
